//const { $ } = window;
//const $body = $( document.body )

export default {
	init() {
      $('.btn-clipboard').on('click', function(e) {
         e.preventDefault();
         var a = this;
         var link = a.href;
         console.log(link)
         navigator.clipboard.writeText(link)
      //    data.select();
      //    $(document).execCommand("copy");

      });
	},
	finalize() {

	},
};
